Ext.define('SA.ViewChooser', {
    alias: 'widget.view-chooser',
    extend: 'Ext.Component',

    baseCls: 'sa-view-chooser',
    cls: 'x-unselectable',
    data: {add: {selected: false}, views: []},
    viewsNeedingNewBadge: {},

    plugins: [{
        ptype: 'sa-drag-reorder',

        itemDragCls: 'sa-view-chooser-item-drag',
        itemSelector: '.sa-view-chooser-item-draggable',

        afterDrag(itemEl) {
            itemEl.focus();
        },

        afterMove(oldIndex, newIndex) {
            var projectView = this.cmp.projectView,
                project = projectView.getProject();

            project.moveView(oldIndex, newIndex);

            project.save();
        },

        getScrollEl() {
            return this.cmp.el.down('.sa-view-chooser-scroll-wrapper', true);
        }
    }],

    tpl: [
        '<div class="sa-view-chooser-heading">',
        '<button data-index="add" data-ref-id="addBtn" class="sa-view-chooser-item sa-view-chooser-new-view <tpl if="add.selected"> sa-view-chooser-item-selected</tpl><tpl if="add.disabled"> sa-view-chooser-item-disabled</tpl>">',
            'New View<svg class="sa-view-chooser-new-view-icon"><use href="#sa-icon-plus"></use></svg>',
        '</button>',
        '</div>',
        '<div class="sa-view-chooser-scroll-wrapper">',
            '<tpl for="views">',
                '<button data-index="{#}" data-ref-id="{refId}" class="sa-view-chooser-item sa-view-chooser-item-draggable<tpl if="selected"> sa-view-chooser-item-selected</tpl><tpl if="new"> sa-view-chooser-item-new</tpl>">',
                    '<div class="sa-view-chooser-item-menu-btn">&nbsp;</div>',
                    '<svg aria-hidden="true" class="sa-view-chooser-icon"><use href="#{icon}"></use></svg>',
                    '<div class="sa-view-chooser-name<tpl if="selected"> sa-view-chooser-name-editable</tpl>">{name:htmlEncode}</div>',
                    '<tpl if="censusReleaseRange"><div class="sa-view-chooser-census-release-range-badge">{censusReleaseRange}</div></tpl>',
                    '<div class="sa-view-chooser-new-badge">NEW</div>',
                '</button>',
            '</tpl>',
        '</div>'
    ],

    initEvents() {
        var me = this,
            renameMenu;

        this.callParent();

        this.el.on({
            delegate: '.sa-view-chooser-item',
            scope: this,

            click(ev, target) {
                if (Ext.fly(target).hasCls('sa-view-chooser-item-disabled')) {
                    return;
                }

                var projectView = this.projectView,
                    project = projectView.getProject(),
                    index = target.getAttribute('data-index'),
                    isAddBtn = index === 'add',
                    view = !isAddBtn && project.getViews()[index - 1],
                    hit = view || project,
                    mode = isAddBtn ? 'edit' : 'view';

                if (view && Ext.fly(ev.target).hasCls('sa-view-chooser-item-menu-btn')) {
                    me.showViewMenu(view, target);

                    return;
                }

                SA.AppController.showProjectView(hit, mode);

                if (hit !== project) {
                    this.fadeNewBadgeForView(hit);
                }
            },

            mouseout(ev, target) {
                if (me.getPlugin('sa-drag-reorder').isDragging() || Ext.fly(target).hasCls('sa-view-chooser-item-disabled')) {
                    return;
                }

                Ext.fly(target).removeCls('sa-view-chooser-item-over');
            },

            mouseover(ev, target) {
                if (Ext.fly(target).hasCls('sa-view-chooser-item-disabled')) {
                    return;
                }

                Ext.fly(target).addCls('sa-view-chooser-item-over');
            }
        });

        this.el.on({
            delegate: '.sa-view-chooser-name-editable',
            scope: this,

            click(ev, target) {
                var projectView = this.projectView;

                if (renameMenu && renameMenu.wasRecentlyVisible()) {
                    return;
                }

                renameMenu = Ext.widget({
                    xtype: 'rename-menu',

                    alignment: 'left',
                    name: projectView.getName(),
                    positionEl: target,
                    target: this,
                    track: true,

                    handler(name) {
                        projectView.setName(name);
                        projectView.save();
                    }
                });
            },

            mouseout(ev, target) {
                Ext.fly(target).removeCls('sa-view-chooser-name-over');
            },

            mouseover(ev, target) {
                Ext.fly(target).addCls('sa-view-chooser-name-over');
            }
        });

        SA.Viewport.on('resize', this.updateTabOverflow, this);
    },

    fadeNewBadgeForView(view){
        var views = this.projectView.getProject().getViews(),
            index = views.indexOf(view),
            itemEl;

        if (index !== -1) {
            this.viewsNeedingNewBadge[view.getUiId()] = false;

            itemEl = this.el.down('[data-index="' + (index + 1) + '"]', true);
            Ext.fly(itemEl).removeCls('sa-view-chooser-item-new');
        }
    },

    onBoxReady() {
        this.callParent();

        this.updateTabOverflow();
    },

    refresh() {
        var el = this.el,
            scroller = el.down('.sa-view-chooser-scroll-wrapper', true),
            projectView = this.projectView,
            project = projectView.getProject(),
            views = project.getViews(),
            scroll = 0,
            selectedView,
            viewData = [],
            viewsNeedingNewBadge = this.viewsNeedingNewBadge,
            getButtons = () => this.el.query('.sa-view-chooser-item'),
            focusedBtn = getButtons().find(el => el === document.activeElement) ?? null,
            focusedBtnRefId = focusedBtn?.dataset.refId ?? null;

        if (scroller) {
            scroll = Ext.Number.constrain((scroller.scrollTop / (scroller.scrollHeight - scroller.clientHeight)) || 0, 0 , 1);
        }

        views.forEach(view => {
            var isSelected = view === projectView,
                uiId = view.getUiId(),
                needsBadge;

            if (!(uiId in viewsNeedingNewBadge)) {
                viewsNeedingNewBadge[uiId] = !view.getId();
            }

            needsBadge = viewsNeedingNewBadge[uiId];

            if (isSelected && needsBadge) {
                setTimeout(() => this.fadeNewBadgeForView(view), 8000);
            }

            viewData.push(Object.assign({
                new: needsBadge,
                selected: isSelected
            }, this.viewToData(view)));
        });

        this.update({
            overview: {selected: projectView === project && this.viewMode === 'view'},
            views: viewData,

            add: {
                disabled: false,
                selected: projectView === project && this.viewMode === 'edit'
            }
        });

        this.updateTabOverflow();

        scroller = el.down('.sa-view-chooser-scroll-wrapper', true);

        if (scroll) {
            scroller.scrollTop = scroll * (scroller.scrollHeight - scroller.clientHeight);
        }

        if (scroller) {
            selectedView = Ext.fly(scroller).down('.sa-view-chooser-item-selected');

            if (selectedView) {
                selectedView.scrollIntoView(scroller, false);
            }
        }

        if (focusedBtnRefId !== null) {
            getButtons().find(el => el.dataset.refId === focusedBtnRefId)?.focus();
        }
    },

    set({model: newProjectView, mode}) {
        var oldProjectView = this.projectView,
            oldMode = this.viewMode,
            newProject = newProjectView.getProject();

        if (newProjectView !== newProject) {
            mode = 'view';
        }

        if (oldProjectView && oldProjectView.getProject() !== newProject) {
            this.viewsNeedingNewBadge = {};
        }

        if (oldProjectView !== newProjectView || oldMode !== mode) {
            Ext.destroy(this.projectListeners);

            this.projectListeners = this.mon(newProject, {
                'change:attribute': this.refresh,
                'change:businessSearch': this.refresh,
                'change:location': this.refresh,

                'change:view': this.refresh,
                'change:view:name': this.refresh,

                destroyable: true,
                scope: this
            });

            this.projectView = newProjectView;
            this.viewMode = mode;

            this.refresh();

            this.fadeNewBadgeForView(oldProjectView);
        }
    },

    setView(model) {
        this.set({model, mode: null}); 
    },

    showViewMenu(view, target) {
        Ext.widget({
            xtype: 'menu',

            items: [
                {
                    text: 'Edit',

                    handler() {
                        SA.AppController.showProjectView(view, 'edit');
                    }
                }, {
                    text: 'Rename',

                    handler: () => {
                        Ext.widget({
                            xtype: 'rename-menu',
                            alignment: 'left',
                            name: view.getName(),
                            positionEl: target,
                            target: this,

                            handler(name) {
                                view.setName(name);
                                view.save();
                            }
                        });
                    }
                }, {
                    xtype: 'menuseparator'
                }, {
                    text: 'Delete',

                    handler() {
                        var project = view.getProject();

                        project.removeView(view);
                        project.save();
                    }
                }
            ],

            listeners: {
                hide: Ext.destroy
            },

            plugins: [{
                ptype: 'sa-arrow',
                bias: 0.15,
                target
            }]
        }).showBy(target, 'tr-tl', [-7, 0]);
    },

    updateTabOverflow() {
        if (!this.el) {
            return;
        }

        var el = this.el,
            scrollWrapper = el.down('.sa-view-chooser-scroll-wrapper', true),
            oldWidth = el.getWidth(),
            scrollWidth, newWidth;

        el.setWidth(100);

        scrollWidth = scrollWrapper.scrollWidth;

        newWidth = 200 - scrollWidth;

        el.setWidth(newWidth);

        if (newWidth !== oldWidth) {
            this.fireEvent('resize');
        }
    },

    viewToData(view) {
        return {
            name: view.getName(),
            refId: view.getUiId(),
            icon: SA.view.ViewTypes.getIcon(view.getType()),
            censusReleaseRange: view.hasHistoricalCensusRelease() ? view.getCensusReleaseRange().join('–') : null
        };
    }
});
